"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
var i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
var hashDetector = {
    name: 'hash',
    lookup: function () {
        var hash = window.location.hash;
        var params = hash.split('/');
        if (params.length <= 1) {
            return null;
        }
        var lang = params[1];
        if (lang && ['fr', 'en'].includes(lang)) {
            return lang;
        }
        return null;
    }
};
i18next_1["default"]
    .use(i18next_http_backend_1["default"])
    .use(i18next_browser_languagedetector_1["default"])
    .use(react_i18next_1.initReactI18next)
    .init({
    fallbackLng: 'en',
    saveMissing: true,
    debug: false,
    backend: {
        loadPath: '/locales/{{lng}}.json'
    },
    detection: {
        order: ['hash', 'cookie', 'localStorage', 'navigator'],
        caches: ['cookie'],
        lookupCookie: 'i18next',
        cookieMinutes: 10080,
        lookupLocalStorage: 'i18nextLng'
    }
});
i18next_1["default"].services.languageDetector.addDetector(hashDetector);
exports["default"] = i18next_1["default"];
